module.exports = "/next-static/_next/static/images/browserBasedZeroSetup-db092412812a272e441152b6cee161cc.png";